
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 32 32"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M6 14a2 2 0 11.001 3.999A2 2 0 016 14zm10 0a2 2 0 11.001 3.999A2 2 0 0116 14zm10 0a2 2 0 11.001 3.999A2 2 0 0126 14z"}})])
          )
        }
      }
    